import NumericField, { getNumericFieldRegisterProps } from './NumericField';

const registerProps = getNumericFieldRegisterProps('Invalid monthly debts value');

const MonthlyDebtField = props => (
    <NumericField
        leftAdornment="$"
        rightAdornment="/month"
        labelText="Monthly debts"
        helpText="Include minimum payments for car or student loans, credit cards, child support and alimony. Exclude
current rent or mortgage."
        registerProps={registerProps}
        {...props}
    />
);

export default MonthlyDebtField;
